import { all, takeLatest } from "redux-saga/effects";
import { FETCH_GALLERY_REQUEST, DELETE_GALLERY_REQUEST } from "./constants";
import {
  fetchGallerySuccess,
  fetchGalleryFailure,
  deleteGallerySuccess,
  deleteGalleryFailure,
} from "./actions";
import { apiSaga, authedApiSaga } from "sagas";
import { getGallery, deleteGallery } from "utils/api";

export function* galleryFlow({ payload }) {
  const args = {
    slug: payload.slug,
    params: getFetchParams(payload.params),
  };
  yield* apiSaga(getGallery, [args], fetchGallerySuccess, fetchGalleryFailure);
}

export function* deleteGalleryFlow({ gifId }) {
  yield* authedApiSaga(
    deleteGallery,
    [{ gifId }],
    () => deleteGallerySuccess({ gifId }),
    deleteGalleryFailure
  );
}

export default function* watchGallery() {
  yield all([
    takeLatest(FETCH_GALLERY_REQUEST, galleryFlow),
    takeLatest(DELETE_GALLERY_REQUEST, deleteGalleryFlow),
  ]);
}

const getFetchParams = (params) => {
  return params
    ? `?${Object.keys(params)
        .map((k) =>
          k === "page"
            ? `${k}=${params[k]}`
            : params[k]
            ? `${k}=${params[k]}`
            : null
        )
        .filter((x) => x)
        .join("&")}`
    : "";
};
